import * as React from 'react';
import { createTheme } from '../Theme/Theme';
// Default context is handled in accessors (hook/HoC). We don't statically define default
// context here because we want to fall back to context from the window.
export var FlowWebContext = /*#__PURE__*/React.createContext(undefined);
export var defaultContext = {
  theme: createTheme(),
  scrollOffset: 0
};